export const USER_GROUP = "emerge9-user-group";
export const GOOGLE_PROVIDER = "Google";
export const INVITATION_NEEDED = "registration_invitation_only";
export const GOOGLE_SIGNIN_ENABLED = "google-signin";
